export default "__VITE_ASSET__ChN9K8Nv__"